import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ServiceHelpersService {
  public options: object = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Content-Type': 'application/json;charset=utf-8',
    }),
  };

  convertDateOfBirth(dateOfBirth) {
    const splittedDate = dateOfBirth.split('/');
    return `${splittedDate[2]}-${splittedDate[0]}-${splittedDate[1]}`;
  }

  formInsuredFullName(firstName, lastName) {
    return `${firstName} ${lastName}`.replace('DEFAULT', '');
  }

  creatUserObject(items, db, zipCode?: string): object {
    let pn: any;
    const pword = items.password || null;

    if (items.policyDetail) {
      if (items.policyDetail.policynumber.length > 1) {
        pn = items.policyDetail.policynumber;
      } else {
        pn = [
          {
            policyNumber:
              items.policyDetail.policynumber.policyNumber ||
              items.policyDetail.policynumber[0].policyNumber,
          },
        ];
      }
    }

    const btoaPass = window.btoa(pword);
    let obj;
    if (db == 'createaccount') {
      obj = {
        customer: {
          firstName: items.userDetails.firstName,
          middleName: items.userDetails.middleName,
          lastName: items.userDetails.lastName,
          email: {
            email: items.userDetails.email.address,
          },
          publicId: items.userDetails.publicId,
        },
        policynumbers: pn,
        credentials: {
          email: items.userDetails.email.address,
          password: btoaPass,
        },
      };
    } else if (db == 'personalpolicy') {
      obj = {
        firstName: items.userDetails.firstName || '',
        middleName:
          (items.userDetails.middleName == 'DEFAULT'
            ? ''
            : items.userDetails.middleName) || '',
        lastName: items.userDetails.lastName || '',
      };
    } else if (db == 'verifyuser') {
      obj = {
        firstName: items.userDetails.firstName,
        middleName:
          (items.userDetails.middleName == 'DEFAULT'
            ? ''
            : items.userDetails.middleName) || '',
        lastName:
          (items.userDetails.lastName ? items.userDetails.lastName : '') || '',
        email: {
          email: items.userDetails.email.address,
        },
        insuredFullName: this.formInsuredFullName(
          items.userDetails.firstName,
          items.userDetails.lastName
        ),
      };
    } else if (db == 'validateCustomer') {
      obj = {
        firstName: items.userDetails.firstName,
        middleName:
          (items.userDetails.middleName == 'DEFAULT'
            ? ''
            : items.userDetails.middleName) || '',
        lastName:
          (items.userDetails.lastName ? items.userDetails.lastName : '') || '',
        dateOfBirth: this.convertDateOfBirth(items.userDetails.dateOfBirth),
        zipCode: items.userDetails.zipCode,
        insuredFullName: this.formInsuredFullName(
          items.userDetails.firstName,
          items.userDetails.lastName
        ),
      };
    } else if ((db === 'verifyAndAdd')) {
      obj = this.convertNameToFormat(
        items.userDetails.firstName,
        (items.userDetails.middleName == 'DEFAULT'
          ? ''
          : items.userDetails.middleName) || '',
        (items.userDetails.lastName ? items.userDetails.lastName : '') || '',
        items.userDetails.email.address,
        zipCode
      );
    }
    return obj;
  }

  convertNameToFormat(
    insurerFirstName: string,
    middleName: string,
    lastName: string,
    email: string,
    zipCode: string
  ) {
    const obj: any = {};
    const insuredNamearray = insurerFirstName.split(' ');
    const middleNameTrim = middleName ? middleName.trim() : '';
    const lastNameTrim = lastName ? lastName.trim() : '';

    if (
      insuredNamearray.length >= 3 &&
      middleNameTrim.length === 0 &&
      lastNameTrim.length === 0
    ) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = insuredNamearray[1];
      obj['lastName'] = insuredNamearray[2];
      obj['email'] = { email };
    } else if (
      insuredNamearray.length == 2 &&
      middleNameTrim.length === 0 &&
      lastNameTrim.length === 0
    ) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = '';
      obj['lastName'] = insuredNamearray[1];
      obj['email'] = { email };
    } else if (
      insuredNamearray.length == 1 &&
      middleNameTrim.length === 0 &&
      lastNameTrim.length === 0
    ) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = '';
      obj['lastName'] = '';
      obj['email'] = { email };
    } else if (middleNameTrim.length > 0 && lastNameTrim.length === 0) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = middleNameTrim;
      obj['lastName'] = '';
      obj['email'] = { email };
    } else if (lastNameTrim.length > 0 && middleNameTrim.length === 0) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = '';
      obj['lastName'] = lastNameTrim;
      obj['email'] = { email };
    } else if (lastNameTrim.length > 0 && middleNameTrim.length > 0) {
      obj['firstName'] = insuredNamearray[0];
      obj['middleName'] = middleNameTrim;
      obj['lastName'] = lastNameTrim;
      obj['email'] = { email };
    }
    obj['zipCode'] = zipCode;
    obj['insuredFullName'] = this.formInsuredFullName(
      insurerFirstName,
      lastName
    );
    return obj;
  }
}
